import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES_VALUE } from '../data/offer';
const bonuses = [{
  number: '01',
  title: 'Il Caveau delle Prove di Progresso',
  price: '€29',
  body: 'La raccolta di dispositivi per rendere visibile il progresso: griglie di avanzamento, confronto tra la seduta 1 e la seduta in corso, formati di restituzione. È il bonus più allineato al metodo: risolve esattamente il punto in cui i percorsi si interrompono.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f169cc27-543f-4460-9ebc-e15bed6822b8.jpg'
}, {
  number: '02',
  title: 'Il Kit Trasformazione della Consegna Premium',
  price: '€24',
  body: 'Come consegnare quello che produci in seduta: format dei documenti, struttura del dossier, standard di presentazione. La stessa sostanza, in una forma che il cliente riconosce come professionale.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/de9c934a-65b6-4391-91f3-e44ff061a028.jpg'
}, {
  number: '03',
  title: 'Il Protocollo di Emergenza per il Cliente Bloccato',
  price: '€19',
  body: 'Il pronto intervento per la seduta che si sta incagliando: sequenza di domande, uscite dal loop, riformulazione dell’obiettivo. Da tenere aperto mentre la seduta è in corso.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b5a99bb7-bca1-4ba4-8769-2ea87459eafa.jpg'
}, {
  number: '04',
  title: 'Il Sistema di Preparazione in 10 Minuti',
  price: '€15',
  body: 'La routine che elimina la preparazione da zero: cosa rileggere, cosa scegliere, cosa portare in seduta. Dieci minuti prima, non un’ora.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b14e8297-002f-460a-bc70-ee61219b7838.jpg'
}, {
  number: '05',
  title: 'Kit Documenti del Coach Professionista',
  price: '€39',
  body: 'Accordo di percorso, informativa privacy GDPR, politica di cancellazione, modello di attestato e di fattura. Esiste solo in questa edizione italiana.',
  note: 'Non costituisce consulenza legale: è consigliata una revisione da parte di un professionista.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bdc9b454-05ad-4650-818f-d2ca110e8c60.jpg'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-white" data-id="element-26" data-mp="3qheckgrg6jxw">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-27" data-mp="2tt80j8s74p9l">
        <div className="text-center" data-id="element-28" data-mp="2xu0bc6gpv27z">
          <span className="inline-flex items-center gap-2 rounded-full bg-terracotta-soft text-terracotta px-4 py-2 text-xs font-bold uppercase tracking-[0.12em]" data-id="element-29" data-mp="2xv1wj3rg553f">
            <GiftIcon className="w-4 h-4" aria-hidden="true" data-id="element-30" data-mp="37jjtf9wlus1s" />
            5 bonus professionali inclusi
          </span>
          <h2 id="bonuses-heading" className="mt-5 font-serif font-bold text-ink text-2xl sm:text-4xl leading-snug max-w-3xl mx-auto" data-id="element-31" data-mp="2a57n6w6c5ynx">
            Valore totale:{' '}
            <span className="line-through text-ink-muted" data-id="element-32" data-mp="27k9n9ck7q8gk">{BONUSES_VALUE}</span>{' '}
            <span className="text-vital" data-id="element-33" data-mp="22kewd90ftivi">→ inclusi</span> con Il Sistema
            Completo del Coach
          </h2>
        </div>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-34" data-mp="1xkip90wg1bbq">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col rounded-2xl bg-cream border border-cream-dark shadow-card overflow-hidden" data-id="element-35" data-mp="1tjyrbv41q3oj">
              <div className="bg-white border-b border-cream-dark" data-id="element-36" data-mp="1jtnfzni18s7m">
                <img src={bonus.image} alt={`${bonus.title} — copertina del bonus`} className="w-full h-52 sm:h-56 object-contain" loading="lazy" data-id="element-37" data-mp="1eusxynrw37ok" />
              </div>
              <div className="flex items-center justify-between gap-3 p-6 pb-0" data-id="element-38" data-mp="15wqodju3b6po">
                <span className="font-serif font-bold text-sm text-terracotta tracking-[0.14em] uppercase" data-id="element-39" data-mp="10w2zp4tc31ym">
                  Bonus {bonus.number}
                </span>
                <span className="flex items-center gap-2" data-id="element-40" data-mp="34znt2g8juthb">
                  <span className="text-sm text-ink-muted line-through" data-id="element-41" data-mp="3518pycic6oic">
                    {bonus.price}
                  </span>
                  <span className="rounded-full bg-vital text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-id="element-42" data-mp="2w6ar6osichj3">
                    Incluso
                  </span>
                </span>
              </div>
              <h3 className="mt-3 px-6 font-serif font-bold text-lg sm:text-xl text-ink leading-snug" data-id="element-43" data-mp="2m9pjtwt0muc3">
                {bonus.title}
              </h3>
              <div className="mt-3 px-6 pb-6 flex-grow" data-id="element-44" data-mp="2d884whrcgyoz">
                <p className="text-[15px] leading-relaxed text-ink-soft" data-id="element-45" data-mp="2d8roe2wn7v54">
                  {bonus.body}
                </p>
                {bonus.note && <p className="mt-3 text-xs leading-relaxed text-ink-muted italic" data-id="element-46" data-mp="bheknh6evtan">
                    {bonus.note}
                  </p>}
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}